import { invoke, requestJira } from "@forge/bridge";
import { QueryClient } from "@tanstack/react-query";
import { formatPrice } from "./shopHandlers";

export const documentReady = (fn) => {
  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
};

const defaultQueryFn = async ({ queryKey }) => {
  const [functionName, data] = queryKey;
  return new Promise((resolve, reject) => {
    invoke(functionName, data).then(resolve).catch(reject);
  });
};

export const formatPriceWithCurrency = ({
  locale = "en-US",
  price,
  currency,
}) =>
  currency
    ? new Intl.NumberFormat(locale, {
        currency,
        style: "currency",
        currencyDisplay: "narrowSymbol",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(price)
    : formatPrice(price);

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: defaultQueryFn,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  },
});

export const getCreatedDateOfIssue = async (issueId) =>
  requestJira(`/rest/api/3/issue/${issueId}?fields=created`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((res) => res.json())
    .then((data) => data.fields.created)
    .catch((err) => console.log(err));
